import { render, staticRenderFns } from "./goodsPurchaseReturnDetail.vue?vue&type=template&id=a98c5114&scoped=true"
import script from "./goodsPurchaseReturnDetail.vue?vue&type=script&lang=js"
export * from "./goodsPurchaseReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsPurchaseReturnDetail.vue?vue&type=style&index=0&id=a98c5114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98c5114",
  null
  
)

export default component.exports